import { useState } from "react";

import { Button, Menu, Dropdown, MenuItem, Icon } from "@aidron/aidron-ds";

import { i18n } from "../../../translate/i18n";

import styled from "styled-components";

const StyledButton = styled(Button)`
  background-color: transparent !important;
  border: unset !important;

  &,
  &.button-primary-medium:hover {
    box-shadow: none !important;
  }

  &.button.button-filled.button-primary-medium:focus {
    background-color: unset;
    border: unset;
  }

  svg {
    color: ${({ color }) => (color ? color : "")};
  }
`;

export function LanguageSelector({ ctx }) {

  const { iconColor = "" } = ctx || {};

  const [open, setOpen] = useState(false);

  const { t } = i18n;

  const I18N_STORAGE_KEY = "i18nextLng";

  const changeLanguage = (languageCode) => {
    localStorage.setItem(I18N_STORAGE_KEY, languageCode);
    window.location.reload(false);
    setOpen(!open);
  }

  return (
    <div className="language-selector">
      <Menu>
        <StyledButton
          icon="chevron-down"
          label=""
          onClick={() => {
            setOpen(!open);
          }}
          position="right"
          color={iconColor}
        >
          <Icon icon="globe" size="30" />
        </StyledButton>
        <Dropdown position="bottom" open={open} setOpen={setOpen}>
          <MenuItem onClick={() => changeLanguage("pt-BR")}>{t("languagePortuguese")}</MenuItem>
          <MenuItem onClick={() => changeLanguage("en-US")}>{t("langaugeEnglish")}</MenuItem>
        </Dropdown>
      </Menu>
    </div>
  );
}
